// extracted by mini-css-extract-plugin
export default {"geniusBadge":"FlightCardBadge-module__geniusBadge___nii7D","badge":"FlightCardBadge-module__badge___QLdsq"};